import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  payments: [],
};

const reducers = {
  getAdminUserList: (state, action) => {
    const newItems = action.payload.items;

    state.users = newItems;
  },
  updateUserStatus: (state, action) => {
    const tempItems = [...state.users];
    const itemId = action.payload.id;

    console.log("updated one... 1", itemId);

    for (let i = 0; i < tempItems.length; i++) {
      console.log("updated one... 2");
      if (itemId === tempItems[i].id) {
        console.log("updated one... 3");

        tempItems[i].blocked = !tempItems[i].blocked;
      }
    }

    state.users = tempItems;
  },
  updateAdminUserList: (state, action) => {
    const tempItems = [...state.users];
    const updateItem = action.payload.item;

    const index = tempItems.findIndex((item) => item.id === updateItem.id);

    state.users[index] = updateItem;
  },
  delteUserListItem: (state, action) => {
    const tempItems = [...state.users];
    const itemId = action.payload.id;

    const updatedLlist = tempItems.filter((item) => item.id !== itemId);

    state.users = updatedLlist;
  },
};

const bookingsSlice = createSlice({
  name: "bookings",
  initialState,
  reducers,
});

export const {
  getAdminUserList,
  updateAdminUserList,
  delteUserListItem,
  updateUserStatus,
} = bookingsSlice.actions;

export default bookingsSlice.reducer;
